<template>
  <custom-table
    class="in-house-table"
    :loading="tableLoading"
    :table-data="list"
    :pagination="pagination"
    height="100%"
    @handleSizeChange="handlePaginationChange"
    @handleCurrentChange="handlePaginationChange"
  >
    <el-table-column prop="templateName" label="模块" width="120">
      <template slot-scope="scope">
        {{ scope.row.templateName || scope.row.templateCode }}
      </template>
    </el-table-column>
    <el-table-column
      v-for="(cm, index) in tableColumns"
      :key="`${type}-${cm.field}-${uniqueIndex}-${index}`"
      :label="cm.name"
      :index="index"
      :width="cm.width"
      :min-width="cm.minWidth"
      :fixed="cm.fixed"
    >
      <template slot-scope="scope">
        <cell-tooltip :text="scope.row[cm.field]" :width="cm.width" />
      </template>
    </el-table-column>
    <el-table-column label="执行状态" width="100">
      <template slot-scope="scope">
        <div :class="['excel-status', fileStatus(scope.row).status]">{{ fileStatus(scope.row).label }}</div>
      </template>
    </el-table-column>
    <el-table-column v-if="type === 'IMPORT'" label="操作" width="200" fixed="right">
      <template slot-scope="scope">
        <div v-if="fileStatus(scope.row).status !== 'pending'" class="inline-block">
          <span>成功:</span><em>{{ scope.row.successCount }}</em>
          <span class="ml-1">失败:</span><em class="text-red-600">{{ scope.row.failCount }}</em>
          <!-- <svg-icon icon-class="download" class="ml-4 cursor-pointer primary-color" @click="downloadFile(scope.row)"></svg-icon> -->
          <el-button  type="text" @click="downloadFile(scope.row)">下载</el-button>
        </div>
        <div v-else></div>
      </template>
    </el-table-column>
    <el-table-column v-if="type === 'EXPORT'" show-overflow-tooltip width="120" fixed="right">
      <template slot-scope="scope">
        <el-button v-if="fileStatus(scope.row).status === 'success'" type="text" @click="downloadFile(scope.row)">下载</el-button>
      </template>
    </el-table-column>
  </custom-table>
</template>

<script>
import ExcelApi from "@/api/excel";
import CellTooltip from "@/components/private/cell-tooltip";
export default {
  name: "ExcelRecord",
  components: { CellTooltip },
  props: {
    queryData: {
      type: Object,
      default: () => {}
    },
    type: {
      type: String,
      default: "IMPORT"
    }
  },
  data() {
    return {
      uniqueIndex: 1,
      pagination: {
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      importTableColumns: [
        {
          name: "日志",
          field: "message",
          width: "auto",
          minWidth: "200"
        },
        {
          name: "任务开始时间",
          field: "executeTimeStart",
          width: "200"
        },
        {
          name: "任务结束时间",
          field: "executeTimeStart",
          width: "200"
        },
        {
          name: "操作人",
          field: "operator",
          width: "100"
        }
      ],
      exportTableColumns: [
        {
          name: "日志",
          field: "message",
          width: "200"
        },
        {
          name: "任务开始时间",
          field: "executeTimeStart"
        },
        {
          name: "任务结束时间",
          field: "executeTimeStart"
        },
        {
          name: "操作人",
          field: "operator",
          width: "100"
        }
      ],
      tableLoading: false,
      list: []
    };
  },
  computed: {
    tableColumns() {
      if (this.type === "IMPORT") {
        return this.importTableColumns;
      }

      return this.exportTableColumns;
    },
    fileStatus() {
      return item => {
        if (item.state === "SUCCEED") {
          return {
            status: "success",
            label: "成功"
          };
        }
        if (item.state === "PROCESSING") {
          return {
            status: "pending",
            label: "处理中"
          };
        }

        return {
          status: "failed",
          label: "失败"
        };
      };
    }
  },
  watch: {
    queryData: {
      immediate: true,
      deep: true,
      handler() {
        this.uniqueIndex++;
        this.loadData();
      }
    }
  },
  methods: {

    loadData() {
      this.list = [];
      const params = {
        type: this.type,
        page: this.pagination.pageNum,
        size: this.pagination.pageSize,
        "orders[0].asc": false,
        "orders[0].column": "createTime",
        ...(this.queryData || {})
      };

      ExcelApi.importExcelRecord(params).then(res => {
        if (res.success) {
          const { data } = res;
          if (data) {
            const { records = [], total = 0 } = data;
            this.list = records;
            this.pagination.total = Number(total);
          }
        }
      });
    },
    handlePaginationChange(data) {
      this.$set(this, "pagination", data);
      this.loadData();
    },
    downloadFile(item) {
      if (item && item.attachmentId) {
        ExcelApi.downloadAttachment(item.attachmentId).then(result => {
          this.streamingFileConversion(result);
        });
      } else {
        this.$message.error("暂未生成文件！");
      }
    },
    // 流文件的转换
    streamingFileConversion(result) {
      const blob = new Blob([result.data], {
        type: "application/vnd.ms-excel"
      }); // 构造一个blob对象来处理数据
      const fileName = result.filename; // 导出文件名
      // 对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
      // IE10以上支持blob但是依然不支持download
      if ("download" in document.createElement("a")) {
        // 支持a标签download的浏览器
        const link = document.createElement("a"); // 创建a标签
        link.download = fileName; // a标签添加属性
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        document.body.appendChild(link);
        link.click(); // 执行下载
        URL.revokeObjectURL(link.href); // 释放url
        document.body.removeChild(link); // 释放标签
      } else {
        // 其他浏览器
        navigator.msSaveBlob(blob, fileName);
      }
    }
  }
};
</script>
